import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import repairService from '../../services/repair';

const initialState = {
  loading: false,
  list: [],
  error: '',
  params: {
    page: 1,
    perPage: 15,
    status: undefined,
    userId: undefined,
    referenceCode: undefined,
  },
  meta: {},
};

export const fetchRepairs = createAsyncThunk(
  'repair/fetchRepairs',
  (params = {}) =>
    repairService.getAll({ ...initialState.params, ...params }).then((res) => res)
);

export const updateRepairStatus = createAsyncThunk(
  'repair/updateRepairStatus',
  ({ id, status }, { dispatch }) =>
    repairService.updateStatus(id, status).then(() => {
      dispatch(fetchRepairs());
      return { id, status };
    })
);

const repairSlice = createSlice({
  name: 'repair',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchRepairs.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRepairs.fulfilled, (state, action) => {
        const payload = action.payload;
        const meta = payload?.meta ?? {};
        state.loading = false;
        state.list = Array.isArray(payload?.data) ? payload.data : [];
        state.meta = meta;
        state.params.page = meta.current_page ?? meta.page ?? state.params.page;
        state.params.perPage = meta.per_page ?? state.params.perPage;
        state.error = '';
      })
      .addCase(fetchRepairs.rejected, (state, action) => {
        state.loading = false;
        state.list = [];
        state.error = action.error?.message ?? '';
      });
  },
});

export default repairSlice.reducer;
